document.addEventListener('DOMContentLoaded', () => {
  // Handle "Add to Design Studio" button clicks on design gallery
  const addButtons = document.querySelectorAll(
    '.design-studio-add-design-button'
  );

  addButtons.forEach(button => {
    button.addEventListener('click', async e => {
      e.preventDefault();
      e.stopPropagation();

      const designId = button.dataset.designId;
      const designUrl = button.dataset.designUrl;
      const artCode = button.dataset.artCode;
      const isPng = button.dataset.isPng === 'true';

      try {
        // Fetch SVG content first if not PNG
        let svgContent = null;
        if (!isPng) {
          try {
            const response = await fetch(`/designs/${designId}/svg_content`);

            if (!response.ok) {
              const text = await response.text();
              try {
                const errorData = JSON.parse(text);
                if (
                  errorData.error &&
                  errorData.error.includes('not in SVG format')
                ) {
                  // It's a PNG, continue without SVG content
                  svgContent = null;
                } else {
                  throw new Error(
                    errorData.error || 'Failed to load design SVG'
                  );
                }
              } catch (jsonError) {
                throw new Error(
                  `Failed to load design SVG: ${response.statusText}`
                );
              }
            } else {
              const data = await response.json();

              if (data.success && data.svg_content) {
                svgContent = data.svg_content;
              } else if (
                data.error &&
                data.error.includes('not in SVG format')
              ) {
                svgContent = null;
              } else {
                throw new Error(data.error || 'Failed to load design');
              }
            }
          } catch (fetchError) {
            svgContent = null;
          }
        }

        // Get current formData from localStorage to work with OrderWizard
        let formData = {};
        try {
          const storedFormData = localStorage.getItem('formData');
          if (storedFormData) {
            formData = JSON.parse(storedFormData);
          } else {
            formData = { isStudent: true, school: 'Other' };
          }
        } catch (e) {
          formData = { isStudent: true, school: 'Other' };
        }

        // Check if this is the first design/product being added
        const isFirstItem = !formData.design && !formData.product;

        // Get thumbnail and fullsize URLs
        const thumbnailUrl = button.dataset.thumbnailUrl;
        const fullsizeUrl = button.dataset.fullsizeUrl;

        // Create new design object
        const newDesign = {
          id: designId,
          url: thumbnailUrl || fullsizeUrl || designUrl,
          thumbnailUrl: thumbnailUrl || fullsizeUrl,
          fullsizeUrl: fullsizeUrl || thumbnailUrl,
          artCode: artCode,
          designUrl: designUrl,
          svgUrl: `/designs/${designId}/svg_content`,
          isPng: isPng || !svgContent,
        };

        // If this is the first design, add it as the main design
        if (!formData.design) {
          formData.design = newDesign;
        }

        // Also update the designCustomization to track multiple designs
        if (!formData.designCustomization) {
          formData.designCustomization = {
            sideDesigns: { front: [], side: [], back: [] },
            designPool: [],
            sideSvgContent: {},
            sideColorMappings: {},
            positions: {},
            sizes: {},
            colorMappings: {},
            transparentColors: [],
          };
        }

        // Convert old format to new array format if needed
        const existingDesigns = formData.designCustomization.sideDesigns || {};
        Object.keys(existingDesigns).forEach(side => {
          if (existingDesigns[side] && !Array.isArray(existingDesigns[side])) {
            existingDesigns[side] =
              existingDesigns[side] === null ? [] : [existingDesigns[side]];
          }
        });

        // Initialize design pool if it doesn't exist
        if (!formData.designCustomization.designPool) {
          formData.designCustomization.designPool = [];
        }

        // Check if design already exists in pool
        const inPool = formData.designCustomization.designPool.some(
          d => String(d.id) === String(designId)
        );
        if (inPool) {
          showFeedback(button, 'Design already in Selected Designs', true);
          return;
        }

        // Check if we have a target side from the Design Studio
        const targetSide = localStorage.getItem('targetDesignSide');
        
        if (targetSide && ['front', 'back', 'side'].includes(targetSide)) {
          // Check if design already exists on this side
          const existsOnSide = formData.designCustomization.sideDesigns[targetSide] && 
            formData.designCustomization.sideDesigns[targetSide].some(
              d => String(d.id) === String(designId)
            );
          
          if (existsOnSide) {
            showFeedback(button, `Design already on ${targetSide}`, true);
            localStorage.removeItem('targetDesignSide');
            return;
          }
          
          // Add directly to the specified side
          if (!formData.designCustomization.sideDesigns[targetSide]) {
            formData.designCustomization.sideDesigns[targetSide] = [];
          }
          formData.designCustomization.sideDesigns[targetSide].push(newDesign);
          
          // Initialize position and size for this design
          const designKey = `${targetSide}-${designId}`;
          formData.designCustomization.positions = formData.designCustomization.positions || {};
          formData.designCustomization.sizes = formData.designCustomization.sizes || {};
          formData.designCustomization.positions[designKey] = { x: 50, y: 50 };
          formData.designCustomization.sizes[designKey] = { width: 40, height: 40 };
          
          // Store SVG content if available
          if (svgContent) {
            if (!formData.designCustomization.sideSvgContent) {
              formData.designCustomization.sideSvgContent = {};
            }
            if (!formData.designCustomization.sideSvgContent[targetSide]) {
              formData.designCustomization.sideSvgContent[targetSide] = {};
            }
            formData.designCustomization.sideSvgContent[targetSide][designId] = svgContent;
          }
          
          // Clear the target side after use
          localStorage.removeItem('targetDesignSide');
        } else {
          // Add to design pool as before
          formData.designCustomization.designPool.push(newDesign);
        }

        // Store updated formData in localStorage
        try {
          localStorage.setItem('formData', JSON.stringify(formData));
        } catch (e) {
          if (e.name === 'QuotaExceededError') {
            alert('Storage quota exceeded. Please clear your browser data.');
          }
        }

        // Dispatch event to notify OrderWizard
        const event = new CustomEvent('LoadDesignFromGallery', {
          detail: {
            id: designId,
            url: thumbnailUrl || fullsizeUrl || designUrl,
            thumbnailUrl: thumbnailUrl,
            fullsizeUrl: fullsizeUrl,
            fromGallery: true,
            openModal: isFirstItem,
          },
        });
        window.dispatchEvent(event);

        // Force storage event to update OrderWizard state
        window.dispatchEvent(new Event('storage'));

        // Update button state
        button.textContent = 'In Design Studio';
        button.classList.remove('button--alt');
        button.classList.add('button--success');
      } catch (error) {
        showFeedback(
          button,
          `Error: ${error.message || 'Error loading design'}`,
          true
        );
      }
    });
  });

  // Clean up old storage keys
  localStorage.removeItem('selectedDesigns');
  localStorage.removeItem('existingDesigns');
  sessionStorage.removeItem('selectedDesigns');

  // Check and update button states for already added designs
  try {
    const storedFormData = localStorage.getItem('formData');
    if (storedFormData) {
      const formData = JSON.parse(storedFormData);
      if (
        formData.designCustomization &&
        formData.designCustomization.sideDesigns
      ) {
        // Get all design IDs that are already in the pool
        const addedDesignIds = [];
        if (formData.designCustomization.designPool) {
          formData.designCustomization.designPool.forEach(design => {
            if (design && design.id) {
              addedDesignIds.push(String(design.id));
            }
          });
        }

        // Update button states
        addButtons.forEach(button => {
          const designId = button.dataset.designId;
          if (addedDesignIds.includes(String(designId))) {
            button.textContent = 'In Design Studio';
            button.classList.remove('button--alt');
            button.classList.add('button--success');
          }
        });
      }
    }
  } catch (e) {
    console.error('Error checking existing designs:', e);
  }
});

function showFeedback(button, message, isError = false) {
  const feedback = document.createElement('div');
  feedback.className = `design-feedback ${isError ? 'error' : 'success'}`;
  feedback.textContent = message;
  feedback.style.cssText = `
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    background: ${isError ? '#ff4444' : '#00bfd5'};
    color: white;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 1000;
    opacity: 0;
    transition: opacity 0.3s ease;
  `;

  button.parentElement.style.position = 'relative';
  button.parentElement.appendChild(feedback);

  // Animate in
  setTimeout(() => (feedback.style.opacity = '1'), 10);

  // Remove after delay
  setTimeout(() => {
    feedback.style.opacity = '0';
    setTimeout(() => feedback.remove(), 300);
  }, 2000);
}
